import { useAuthStore } from '@/store/auth';
import { useSmeAuthStore } from '@/store/sme/sme-auth';
import type { sme_events } from './events/sme-events';
import type { enterprise_events } from './events/enterprise-events';
import { useRoute } from 'vue-router';
import axios from 'axios';

type SmeEventName = keyof typeof sme_events;
type EnterpriseEventName = keyof typeof enterprise_events;

type EventName = SmeEventName | EnterpriseEventName | (string & {});

export type PlatformEventData = {
  event_name: EventName;
  platform?: 'sme' | 'adv' | 'bo';
  metadata?: {
    [key: string]: string | string[] | number | number[] | boolean | boolean[] | object | null;
  };
};

export default function (useSme?: boolean) {
  const authStore = useAuthStore();
  const smeAuthStore = useSmeAuthStore();
  let route: any;

  try {
    route = useRoute();
  } catch {
    route = undefined;
  }

  return {
    async trackEvent({ event_name, platform = 'adv', metadata }: PlatformEventData) {
      const profileId = useSme ? smeAuthStore.smeProfile?.id : authStore.profile?.id;
      const user_id = profileId ?? '';
      const routeBrandId = useSme ? route?.params?.sme_id : route?.params?.company_id;

      const smeCompany = useSme ? smeAuthStore.smeProfile?.companies?.find((company: any) => company.company_role === 'COMPANY') : null;

      const enterpriseCompany = !useSme ? authStore.profile?.companies?.find((company: any) => company.company_role === 'COMPANY') : null;

      const company_id = (useSme ? smeCompany?.id : enterpriseCompany?.id) ?? '';
      const brand_id = routeBrandId ?? '';

      const meta = { user_id, brand_id, account_id: company_id, ...metadata };

      try {
        const response = await axios.post('https://ms.wazii.io/platform-analytics/event', {
          event_name,
          platform,
          metadata: meta,
        });

        return response.data;
      } catch (err) {
        const error = err as Error;
        throw new Error(error.message);
      }
    },
    async logLastId(id: any) {
      try {
        const response = await axios.patch('/user/merchants/last_company', {
          company_id: id,
        });

        return response.data;
      } catch (err) {
        const error = err as Error;
        throw new Error(error.message);
      }
    },
  };
}

/* Composable to be used like this

  import usePlatformAnalytics from '@/composables/usePlatformAnalytics';

  const { trackEvent } = usePlatformAnalytics();

  const platformEventData: PlatformEventData = {
    event_name: 'FetchTest',
    platform: 'adv',
    metadata: {
      'a key': 'the value',
    },
  };

  trackEvent({
    event_name: 'CampaignCreated',
    platform: 'adv',
    metadata: {
      company_id: company_id.value,
      campaign_id: campaignStore.campaignForm.id as string,
      mode: campaignStore.influencerSelectionMode,
    },
  });

*/
